import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo_white.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b716509a")

_pushScopeId("data-v-b716509a")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Forgot Password?")
const _hoisted_4 = {
  key: 2,
  style: {"text-align":"center","color":"var(--f7)"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "No worries, we'll send you reset instructions", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Forgot Password? ")
const _hoisted_7 = {
  key: 4,
  style: {"text-align":"center","margin-top":"20px"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Return to login")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_login_screen_title = _resolveComponent("f7-login-screen-title")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_block_footer = _resolveComponent("f7-block-footer")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_f7_page = _resolveComponent("f7-page")
  const _component_f7_view = _resolveComponent("f7-view")
  const _component_f7_login_screen = _resolveComponent("f7-login-screen")

  return (_openBlock(), _createBlock(_component_f7_login_screen, { id: "login-screen" }, {
    default: _withId(() => [
      _createVNode(_component_f7_view, null, {
        default: _withId(() => [
          _createVNode(_component_f7_page, { "login-screen": "" }, {
            default: _withId(() => [
              _createVNode(_component_f7_block, null, {
                default: _withId(() => [
                  _hoisted_1,
                  (!_ctx.resettingPassword)
                    ? (_openBlock(), _createBlock(_component_f7_login_screen_title, { key: 0 }, {
                        default: _withId(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.resettingPassword)
                    ? (_openBlock(), _createBlock(_component_f7_login_screen_title, { key: 1 }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.resettingPassword)
                    ? (_openBlock(), _createBlock("div", _hoisted_4, [
                        _hoisted_5
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_f7_list, {
                    form: "",
                    id: "login-form"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_list_input, {
                        outline: "",
                        type: "email",
                        name: "email",
                        placeholder: "Email",
                        value: _ctx.username,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.username = $event)),
                        required: ""
                      }, null, 8, ["value"]),
                      (!_ctx.resettingPassword)
                        ? (_openBlock(), _createBlock(_component_f7_list_input, {
                            key: 0,
                            outline: "",
                            type: "password",
                            name: "password",
                            placeholder: "Password",
                            minlength: "6",
                            required: "",
                            value: _ctx.password,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event))
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (!_ctx.resettingPassword)
                        ? (_openBlock(), _createBlock(_component_f7_link, {
                            key: 1,
                            href: "#",
                            style: {"float":"right","margin-top":"0","margin-bottom":"20px"},
                            onClick: _ctx.startPasswordReset
                          }, {
                            default: _withId(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (!_ctx.resettingPassword)
                        ? (_openBlock(), _createBlock(_component_f7_button, {
                            key: 2,
                            type: "submit",
                            onClick: _ctx.signIn,
                            fill: "",
                            text: "Sign In",
                            preloader: "",
                            loading: _ctx.validating
                          }, null, 8, ["onClick", "loading"]))
                        : _createCommentVNode("", true),
                      (_ctx.resettingPassword)
                        ? (_openBlock(), _createBlock(_component_f7_button, {
                            key: 3,
                            onClick: _ctx.resetPassword,
                            fill: "",
                            text: "Reset Password",
                            preloader: "",
                            loading: _ctx.validating
                          }, null, 8, ["onClick", "loading"]))
                        : _createCommentVNode("", true),
                      (_ctx.resettingPassword)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, [
                            _createVNode(_component_f7_link, {
                              href: "#",
                              "icon-f7": "arrow_left",
                              onClick: _ctx.stopPasswordReset
                            }, {
                              default: _withId(() => [
                                _hoisted_8
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_f7_block_footer, { "text-color": "red" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.message), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})